import '../styles/globals.css'
import type { AppProps } from 'next/app'
import { AuthProvider } from '@/lib/authContext'
import { Toaster } from 'react-hot-toast'
import GDPRConsentBanner from '@/components/GDPRConsentBanner'
import Head from 'next/head'
import { useEffect, useState } from 'react'

// ClientOnly wrapper to prevent hydration mismatches
function ClientOnly({ children }: { children: React.ReactNode }) {
  const [hasMounted, setHasMounted] = useState(false)
  
  useEffect(() => {
    setHasMounted(true)
  }, [])
  
  if (!hasMounted) {
    return null
  }
  
  return <>{children}</>
}

export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <AuthProvider>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <Component {...pageProps} />
      <ClientOnly>
        <GDPRConsentBanner />
      </ClientOnly>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#334155',
            color: '#F8FAFC',
            fontFamily: '"Inter", system-ui, sans-serif',
            fontWeight: 300,
            fontSize: '14px',
            borderRadius: '1.5rem',
            padding: '12px 20px',
            border: '1px solid #475569',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#059669',
              secondary: '#F8FAFC',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#dc2626',
              secondary: '#F8FAFC',
            },
          },
        }}
      />
    </AuthProvider>
  )
}
